import React, { Component } from "react";
import { connect } from "react-redux";
import { StoragesSystem } from "../../../@main-module/actions-manager/actions-data";
import { withRouter } from "../../../@hoc/with-router";
import { RenderNodes } from "../../../@render-node";
import dataBody from "../json/body.json";
import dataSections from "../json/sections.json";
import dataComments from "../json/comments.json";
import fonts from "../json/font.json";
import galery from "../json/galery.json";
import { FontHeader } from "../../../@font-header";
import "../scss/style.scss";
import "./print.scss";
import { toPng } from "html-to-image";
import { ButtonActionsGlobal } from "../../../@component/form/buttons/buttons-actions-global";
import { ButtonRender } from "../../../@component/form/buttons/buttons-render";

const PageDefaultProps = {
  StoragesSystem: {
    catalog: [],
  },
};

const FILTERS_KEY = {
  catalog: ["navbar", "header", "stats", "feature", "theme", "pricing", "testimony", "cta", "faq", "footer"],
  feature: ["navbar", "feature", "faq", "footer"],
  theme: ["navbar", "theme", "faq", "footer"],
  price: ["navbar", "pricing", "faq", "footer"],
  portfolio: ["navbar", "stats", "testimony", "cta", "faq", "footer"],
};

class RenderPage extends Component {
  static defaultProps = PageDefaultProps;
  constructor(props) {
    super(props);
    this.state = {
      time: "0",
      isDownload: false,
    };
  }
  timeOut = null;

  componentDidUpdate = (prevProps) => {};

  componentDidMount = () => {
    document.querySelector("body").className = dataBody.className;
    this.setState({ time: new Date().getTime() }, () => {
      this.deleteElement();
      // setTimeout(() => this.onClickDownload(), 5000);
    });
  };

  getRenderData = (sections, filters = []) => {
    if (filters.length > 0) {
      const filtersObj = {};
      for (let i = 0; i < filters.length; i++) {
        filtersObj[filters[i]] = filters[i];
      }
      for (const key in sections) {
        const item = sections[key];
        const sectionKey = item?.media?.["fox-section"];
        if (filtersObj[sectionKey]) {
          // data.sections[key].node = []
        } else {
          item.node = [];
        }
      }
      return sections;
    }
    return sections;
  };
  getSectionFilters = () => {
    const key = this.props.searchParams?.get?.("pages");
    const filters = FILTERS_KEY[key] || [];
    return filters;
  };

  deleteElement = () => {
    const deleteEl = () => {
      const list = [
        // ".elementor-4685 .elementor-element.elementor-element-1776a10a",
        ".elementor-4685 .elementor-element.elementor-element-72e1343d:not(.elementor-motion-effects-element-type-background)",
        ".elementor-4685 .elementor-element.elementor-element-72e1343d > .elementor-motion-effects-container > .elementor-motion-effects-layer",
        ".elementor-4685 .elementor-element.elementor-element-29aaa33a:not(.elementor-motion-effects-element-type-background)",
        ".elementor-4685 .elementor-element.elementor-element-29aaa33a > .elementor-motion-effects-container > .elementor-motion-effects-layer",
        "a.elementor-button",
        ".elementor-4685 .elementor-element.elementor-element-64fb5688 ",
        ".elementor-4685 .elementor-element.elementor-element-73e927e5",
        ".elementor-4685 .elementor-element.elementor-element-949eade > .elementor-widget-container",
        ".desktop-bar",
        ".elementor-4685 .elementor-element.elementor-element-7f0aee5e",
        ".audio-box",
      ];
      list.forEach((key) => {
        const el = document.querySelectorAll(key);
        console.log(key, el);
        el.forEach((elItem) => {
          // elItem.remove();
          elItem.innerHTML = "";
        });
      });
    };
    setTimeout(() => deleteEl(), 1000);
  };

  onClickDownload = async () => {
    this.setState({ isDownload: true }, () => {
      const printEl = document.querySelector(".print_content");
      const childEl = printEl.querySelectorAll(".elementor.elementor-4685.elementor.elementor-4685 > section");
      this.downloadMultiple(printEl, childEl);
    });
  };

  downloadMultiple = async (parent, arrEl) => {
    const naming = window.location.host.split(".")[0];
    const base64ImagePArent = await toPng(parent, {
      cacheBust: true,
      pixelRatio: 2,
      width: parent.clientWidth,
      height: parent.clientHeight,
      style: {
        transform: "none",
        transformOrigin: "top left",
        margin: "0",
      },
    });
    const link = document.createElement("a");

    link.href = base64ImagePArent;
    link.download = `${naming}_Undangan print.png`;
    link.click();

    let lastIndex = 0;

    for (let i = 0; i < arrEl.length; i++) {
      const el = arrEl[i];
      if (el.innerHTML !== "") {
        // eslint-disable-next-line no-loop-func
        await new Promise(async (resolve) => {
          const base64Image = await toPng(el, {
            cacheBust: true,
            pixelRatio: 2,
            width: el.clientWidth,
            height: el.clientHeight,
            style: {
              transform: "none",
              transformOrigin: "top left",
              margin: "0",
            },
          });
          const link = document.createElement("a");

          link.href = base64Image;
          lastIndex += 1;
          link.download = `${naming}_section_${lastIndex}_Undangan print.png`;
          link.click();
          resolve(true);
        });
      }
    }
    this.setState({ isDownload: false });
  };

  getScale = () => {
    const apply = (width, page) => {
      const scale = Math.min(0.5, width / 992);
      return { "--print-scale": String(scale) };
    };
    const page = document.querySelector(".print_page");
    if (page) {
      return apply(page.clientWidth, page);
    }
    return {};
  };

  render() {
    const { props } = this;
    let filters = this.getSectionFilters();
    let renderSections = this.getRenderData(dataSections, filters);
    return (
      <>
        {fonts.length > 0 && <FontHeader fonts={fonts} />}
        <section className="print_page" style={this.getScale()}>
          <div className="print_content">
            <RenderNodes
              {...props}
              dataComments={dataComments}
              isUseMusic={true}
              isUseNavigation={true}
              song={"/images/song.mp3"}
              databaseId={"1lc2iOkhu8r7iukqJa43xId_abifdN5mtJUnGpygkd_w"}
              data={dataBody}
              sections={renderSections}
              galery={galery}
            />
          </div>
          <div className="btn_section">
            <ButtonActionsGlobal onClick={this.onClickDownload} render={() => <ButtonRender>Download</ButtonRender>} />
          </div>
          {this.state.isDownload && <div className="loeading_bar">Downloading...</div>}
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  StoragesSystem: state.StoragesSystem,
});
const mapDispatchToProps = (dispatch) => ({
  setStorage: (data = { data: null, type: "yourkey" }) => dispatch(new StoragesSystem().setStorage(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withRouter(RenderPage, {
    isRestriected: true,
  }),
);
